import { Pipe, PipeTransform } from '@angular/core';

/**
 * This pipe take a language key
 * and transforms it to its language displayName
 * followed by the displayName in users preferredLanguage
 * separated by a hyphen `-`
 * @param value string of source locale
 */
@Pipe( {
    name: 'localePipe',
    standalone: true,
    pure: true
} )
export class LocalePipe implements PipeTransform {
    /**
     * helper function to convert a given lanmguage key
     * into a representation of key language
     * @example
     * <!-- language example -->
     * key = `de` // current value, e.g. in dropdown menu
     *
     * <option>{{ value | localePipe }}</option>
     *
     * results into:  transform('de')
     * <div>German</div>
     * @param key : language key
     * @returns string : containing language displayName in key language
     */
    transform( key: string ): string {
        const dn = new Intl.DisplayNames( [key], { type: 'language' } ).of( key );
        return '' + dn;
    }
}
